import * as THREE from "three";

export interface SceneBundle {
  scene: THREE.Scene;
  renderer: THREE.WebGLRenderer;
  firstPersonCamera: THREE.PerspectiveCamera;
  thirdPersonCamera: THREE.PerspectiveCamera;
  resize: () => void;
  dispose: () => void;
}

export function createScene(canvas: HTMLCanvasElement): SceneBundle {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    powerPreference: "high-performance",
  });
  renderer.setPixelRatio(Math.min(2, globalThis.devicePixelRatio || 1));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.setClearColor(0x87b5d4, 1);

  const scene = new THREE.Scene();
  scene.fog = new THREE.Fog(0x87b5d4, 40, 120);

  const hemi = new THREE.HemisphereLight(0xbfd8ff, 0x4a5c3e, 0.7);
  scene.add(hemi);

  const sun = new THREE.DirectionalLight(0xfff4d1, 0.9);
  sun.position.set(20, 30, 10);
  sun.castShadow = true;
  sun.shadow.mapSize.set(1024, 1024);
  sun.shadow.camera.near = 1;
  sun.shadow.camera.far = 80;
  sun.shadow.camera.left = -40;
  sun.shadow.camera.right = 40;
  sun.shadow.camera.top = 40;
  sun.shadow.camera.bottom = -40;
  scene.add(sun);
  scene.add(sun.target);

  const firstPersonCamera = new THREE.PerspectiveCamera(
    75,
    canvas.clientWidth / Math.max(1, canvas.clientHeight),
    0.05,
    200,
  );

  const thirdPersonCamera = new THREE.PerspectiveCamera(
    60,
    canvas.clientWidth / Math.max(1, canvas.clientHeight),
    0.1,
    200,
  );

  function resize(): void {
    const w = canvas.clientWidth;
    const h = canvas.clientHeight;
    renderer.setSize(w, h, false);
    firstPersonCamera.aspect = w / Math.max(1, h);
    firstPersonCamera.updateProjectionMatrix();
    thirdPersonCamera.aspect = w / Math.max(1, h);
    thirdPersonCamera.updateProjectionMatrix();
  }

  function dispose(): void {
    renderer.dispose();
  }

  return { scene, renderer, firstPersonCamera, thirdPersonCamera, resize, dispose };
}
